// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"home-module--main-container--bZuX8","projects":"home-module--projects--1XqKR"};